import { render, staticRenderFns } from "./SearchHero.vue?vue&type=template&id=37927557&scoped=true&"
import script from "./SearchHero.vue?vue&type=script&lang=js&"
export * from "./SearchHero.vue?vue&type=script&lang=js&"
import style0 from "./SearchHero.vue?vue&type=style&index=0&id=37927557&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37927557",
  null
  
)

export default component.exports